import React, { Component, useEffect, useState } from 'react';
import { Edit, SimpleForm, SelectInput, ReferenceArrayInput, SelectArrayInput, REDUX_FORM_NAME, required, AutocompleteInput, NumberInput, SimpleFormIterator, ArrayInput, TopToolbar, AutocompleteArrayInput, ReferenceInput, RefreshButton, FormDataConsumer, SaveButton, Toolbar, DeleteButton, TextInput, GET_LIST, minLength, maxLength, regex, email } from 'react-admin';
// import { change } from 'redux-form';
// import { cardActionStyle, sdoStatuses, LineItemsSideComponent } from './common';
import { getLocalStorageKey } from '../common/common';
import myDataProvider from '../myRestProvider';
import Select from 'react-select';

import { RUN_TIME_API_ENDPOINT, CommonHeaderOption, DigitalOrderSystem, EmptyPagination } from '../common/common';

const SalesOfficersEdit = (props) => {
  
    const [sale_officer, setSale_officer] = useState({});
    const [businessesData, setBusinessesData] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [successMsg, setSuccessMsg] = useState(false);
    const [validationError, setValidationError] = useState(false);
    const [validationEmailError, setValidationEmailError] = useState(false);
    const [validationPhoneError, setValidationPhoneError] = useState(false);
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
    const [errorMsg, setErrorMsg] = useState(false);
    const [errorMsgText, setErrorMsgText] = useState(null);
    const [saleOffEmail, setSaleOffEmail] = useState('');
    const [saleOffPhone, setSaleOffPhone] = useState('');
    const [saleOffStatus, setSaleOffStatus] = useState('');
    const [originalList, setOriginalList] = useState('');
    const [saleOffNameSapCode, setSaleOffNameSapCode] = useState('');
    const [saleOffList, setSaleOffList] = useState('')

    useEffect(() => {
      const options = CommonHeaderOption();
      const apiUrl = RUN_TIME_API_ENDPOINT;
      options.method = 'GET';
      fetch(`${apiUrl}/sales_officers/${props.id}`, options)
        .then(res => {
          return res.json();
        }).then(jsonD => {
          let obj = {};
          obj.sap_order_materials = jsonD.data;
          obj.loadingShow = false;
          setSale_officer(obj.sap_order_materials);
          setSaleOffEmail(obj.sap_order_materials.email);
          setSaleOffPhone(obj.sap_order_materials.phone);
          setSaleOffStatus(obj.sap_order_materials.status);
          setOriginalList(obj.sap_order_materials.businesses.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label })))
          setSaleOffNameSapCode(obj.sap_order_materials.businesses.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label })))
          setSaleOffList(obj.sap_order_materials.name_sap_code.map(item => ({ 'id': item.id, 'value': item.name_sap_code, 'label': item.name_sap_code })))
          // this.setState({
          //   sale_officer: obj.sap_order_materials,
          //   saleOffEmail: obj.sap_order_materials.email,
          //   saleOffPhone: obj.sap_order_materials.phone,
          //   saleOffStatus: obj.sap_order_materials.status,
          //   originalList: obj.sap_order_materials.businesses.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label })),
          //   saleOffNameSapCode: obj.sap_order_materials.businesses.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label })),
          //   saleOffList: obj.sap_order_materials.name_sap_code.map(item => ({ 'id': item.id, 'value': item.name_sap_code, 'label': item.name_sap_code })),
          // });
        });
    },[])

  const handleChange = e => {
    const arr = [...originalList]

    let result = arr && arr.filter(item => e && e.filter(i => i.id === item.id).length === 0);
    if (e === null) {
      result = [...originalList]
    }
    // console.log('result', result)
    setSaleOffList(e)
    setSaleOffNameSapCode(result)
    // this.setState({
    //   saleOffList: e,
    //   saleOffNameSapCode: result

    // });
  };

  const handleInputChange = e => {
    setSaleOffNameSapCode(saleOffNameSapCode)
    // this.setState({ saleOffNameSapCode: this.state.saleOffNameSapCode });
  }

  const emailChange = (e) => {
    // if (/.+@.+\.[A-Za-z]+$/.test(e.target.value) === false) {
    if (/([a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3})/.test(e.target.value) === false) {
      setValidationError(true);
      setValidationEmailError(true);
      // this.setState({
      //   validationError: true,
      //   validationEmailError: true
      // });
    } else {
      setValidationError(false);
      setValidationEmailError(false);
      // this.setState({
      //   validationError: false,
      //   validationEmailError: false
      // });
    }
    setSaleOffEmail(e.target.value);
    // this.setState({ saleOffEmail: e.target.value });

  };

  const phoneChange = (e) => {
    if (/^\d+$/.test(e.target.value) != true) {
      setValidationError(true);
      setValidationPhoneError(true);
      // this.setState({
      //   validationError: true,
      //   validationPhoneError: true
      // });
    } else {
      setValidationError(false);
      setValidationPhoneError(false);
      // this.setState({
      //   validationError: false,
      //   validationPhoneError: false
      // });
    }

    setSaleOffPhone(e.target.value)
    // this.setState({ saleOffPhone: e.target.value });

  };

  const statusChange = (e) => {
    setSaleOffStatus(e.target.value)
    // this.setState({ saleOffStatus: e.target.value });

  };

  const formSave = () => {
    setShowLoader(true);
    setSaveButtonDisabled(false);
    // this.setState({
    //   showLoader: true,
    //   saveButtonDisabled: false
    // });
    const formData = {
      email: saleOffEmail,
      phone: saleOffPhone,
      status: saleOffStatus,
      name_sap_code: saleOffList
    }

    const apiUrl = RUN_TIME_API_ENDPOINT;
    const options = CommonHeaderOption();
    options.method = 'PUT';
    options.body = JSON.stringify({ formData });
    // fetch(`${apiUrl}/sales_officers/${props.id}`, options)
    fetch(`${apiUrl}/sales_officers/${props?.id}`, options)
      .then(res => {
        console.log('res12...........', res)
        if (res) {
          return res.json();
        }
      }
      )
      .then(res => {
        if (res.errorMsg) {
          setErrorMsg(true);
          setShowLoader(false);
          setErrorMsgText(res.errorMsg)
          // this.setState({
          //   errorMsg: true,
          //   showLoader: false,
          //   errorMsgText: res.errorMsg
          // });
          setTimeout(() => {
            setErrorMsg(true);
            setSaveButtonDisabled(true);
            // this.setState({
            //   errorMsg: false,
            //   saveButtonDisabled: true
            // });
          }, 3000)
        } else {
          console.log('res...........', res)
          setShowLoader(false);
          setSaveButtonDisabled(true);
          setSuccessMsg(true);
          // this.setState({
          //   showLoader: false,
          //   saveButtonDisabled: true,
          //   successMsg: true
          // });
          setTimeout(() => {
            setSuccessMsg(false);
            // this.setState({ successMsg: false });
          }, 2000)
          setTimeout(() => {
            props.history.push("/sales_officers");
          }, 3000)
          console.log('res', res);
        }

      }).catch(error => {
        console.log(error);
      })
  }

  const cancelClick = () => {
    setSaleOffList(null);
    setSaleOffNameSapCode(originalList)
    // this.setState({
    //   saleOffList: null,
    //   saleOffNameSapCode:this.state.originalList
    // });
  }

    return (
      <div className="so-form-container panel-margin-top">
        <div className="so-form">
          <div className="so-input">
            <label>Sales officer Email<sup>*</sup></label>
            <input
              className="form-control"
              type="email"
              name="Email"
              value={saleOffEmail}
              onChange={emailChange}
              validations={[required, email]}
            // onBlur={this.handleChange}
            />
            <div className="valid-emailid">Enter email with Lafarge Holcim business suite. </div>
            {validationEmailError &&
              <p className="so-input-error">Please enter valid email</p>
            }
          </div>
          <div className="so-input">
            <label>Sales officer Phone</label>
            <input
              className="form-control"
              type="text"
              name="Phone"
              maxLength="15"
              value={saleOffPhone}
              onChange={phoneChange}
            />
            {validationPhoneError &&
              <p  className="so-input-error">Please enter valid phone number</p>
            }
          </div>

          <label className="select-label">Choose Retailers<sup>*</sup> (Atleast select one retailer)</label>
          <div className="select-retailer">
            <Select
              value={saleOffList}
              onChange={handleChange}
              // onInputChange={this.handleInputChange}
              options={saleOffNameSapCode}
              isMulti
            />
            <button onClick={cancelClick}>Clear</button>
          </div>
          <label className="select-label2">Login Enabled</label>
          <select value={saleOffStatus} onChange={statusChange}>
            <option value="true">True</option>
            <option value="false">False</option>
          </select>
        </div>
        {saveButtonDisabled &&
          <div className="so-save-button">
            <button className={(!saleOffEmail || !saleOffList || validationEmailError || !saleOffPhone || validationPhoneError) ? 'disable-save' : ''} disabled={validationEmailError || !saleOffEmail || !saleOffList} onClick={() => formSave()}>Save</button>
          </div>
        }
        {showLoader &&
          <div className="save-loader" />
        }
        {successMsg &&
          <div className="so-updated" >
            Successfully updated </div>
        }
        {errorMsg &&
          <div className="so-email-exist" >
            {errorMsgText}</div>
        }
      </div>
    )
}

export default SalesOfficersEdit;